var exports = {
  "az": "Box__l3IzCz",
  "wy": "Box_1__vRncVq",
  "pv": "Box_2__Sojj6x",
  "w9": "Box_3__eg9tXU",
  "pQ": "Box_4__B4qtNd",
  "ws": "Box_5__pr2sgM",
  "l4": "OverviewHeaderRow__Z_ScMh",
  "w2": "OverviewTable__rPbUfl",
  "J1": "ExpandableTable__uFHksq",
  "wW": "OverviewTableBody__ZmULK8",
  "fw": "TruncatedTable__a_EGTc",
  "PE": "ExpandRow__y55Gwk",
};

module.exports = exports;
